import React from 'react';
import TableCell from '@mui/material/TableCell';
const Main = ({ value, columnKey }) => {
    if (columnKey === 'base' || columnKey === 'quote') {
        return (React.createElement(TableCell, { align: columnKey === 'base' ? 'left' : 'right' }, value.toUpperCase() || 'N/A'));
    }
    return (React.createElement(TableCell, { align: "right" }, value || 'N/A'));
};
export default Main;
